import { format, Track, unformat } from '@react-input/mask';

export const MASK_OPTIONS = {
  mask: '+7 (___) ___-__-__',
  replacement: { _: /\d/ },
};

const MASK_PREFIX = MASK_OPTIONS.mask.slice(0, MASK_OPTIONS.mask.indexOf('_'));

/** Оставляет 10 цифр номера, отбрасывая код страны у 11-значных */
export const toLocalDigits = (raw: string) => {
  const digits = raw.replace(/\D/g, '');
  const local =
    digits.length === 11 && (digits[0] === '7' || digits[0] === '8')
      ? digits.slice(1)
      : digits;

  return local.slice(0, 10);
};

export const toDigits = (raw: unknown): string => {
  const str = String(raw ?? '');

  return str.startsWith(MASK_PREFIX)
    ? unformat(str, MASK_OPTIONS)
    : toLocalDigits(str);
};

export const toMasked = (raw: unknown): string =>
  format(toDigits(raw), MASK_OPTIONS);

export const track: Track = ({ inputType, data, value, selectionStart }) => {
  if (inputType !== 'insert' || data === null) {
    return data;
  }

  if (
    selectionStart === 0 &&
    data.length > 1 &&
    data.startsWith(MASK_PREFIX) &&
    value.startsWith(data.slice(0, -1))
  ) {
    return data.slice(-1);
  }

  return selectionStart === 0 ? toLocalDigits(data) : data;
};
